var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.5 30",
    style: {
      enableBackground: "new 0 0 35.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A0DAD;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,4.3c-1-1.6-2.4-2.8-4.2-3.5c-1.9-0.8-4.1-1-6.3-0.4c-2,0.5-4,1.6-5.7,3.1C16,1.9,14,0.8,12,0.3 C9.8-0.2,7.6-0.1,5.7,0.7C4,1.5,2.5,2.7,1.5,4.3S0,7.9,0,10.1c0.2,9.5,14.3,18.2,17.2,19.8c0.2,0.1,0.4,0.1,0.6,0.1s0.4-0.1,0.6-0.1 c2.8-1.6,17-10.3,17.2-19.8C35.5,7.9,35,5.9,33.9,4.3z M33.3,10c-0.1,3.1-2.1,6.7-5.9,10.4c-3.5,3.4-7.6,6-9.6,7.2 c-2-1.2-6-3.8-9.6-7.2c-3.9-3.7-5.9-7.3-6-10.4c0-3.3,1.6-6,4.4-7.2c0.9-0.4,1.9-0.6,2.9-0.6c2.5,0,5.2,1.2,7.5,3.5 c0,0.2,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1s0.3-0.1,0.4-0.2c3.1-3.2,7.1-4.3,10.4-3C31.7,4,33.3,6.7,33.3,10 L33.3,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistActive);
export default __webpack_public_path__ + "static/media/wishlistActive.ccb38f6511304ecd0095cf1253faa533.svg";
export { ForwardRef as ReactComponent };